export default __webpack_public_path__ + "media/images/hometown-4c0e359cedab7cf19d9990f107ae6744.svg";